export default "__VITE_ASSET__bkpH3oyG__"